import {Component} from '@angular/core';
/**
 * \@title List with selection
 */
export class ListSelectionExample {
  typesOfShoes = ['Boots', 'Clogs', 'Loafers', 'Moccasins', 'Sneakers'];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'list-selection-example',
  styleUrls: ['list-selection-example.css'],
  templateUrl: 'list-selection-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ListSelectionExample_tsickle_Closure_declarations() {
/** @type {?} */
ListSelectionExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ListSelectionExample.ctorParameters;
/** @type {?} */
ListSelectionExample.prototype.typesOfShoes;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
